import { render, staticRenderFns } from "./ZyroSvg.vue?vue&type=template&id=21d57eba&scoped=true&"
import script from "./ZyroSvg.vue?vue&type=script&lang=js&"
export * from "./ZyroSvg.vue?vue&type=script&lang=js&"
import style0 from "./ZyroSvg.vue?vue&type=style&index=0&id=21d57eba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d57eba",
  null
  
)

export default component.exports